module.exports = __webpack_public_path__ + "static/img/gaba.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gaba.png
// module id = UNmG
// module chunks = 90